import { ColorCarouselProps } from "common/mapDataToFitCarousel"
import styled from "styled-components"
import { Font } from "../wizard/constants"

const StyledContainer = styled.div`
  padding: 20px 0 0 0;
  display: flex;
  justify-content: center;
  margin: 0 -6px;

  ${(p) => p.theme.breakpoints.up("md")} {
    padding: 30px 15px 0 15px;
    justify-content: flex-start;
    margin: 0 -8px;
    order: -1;
    flex-direction: column;
  }
`
const StyledRadio = styled.input`
  position: absolute;
  border: 0;
  margin: -1px;
  padding: 0;
  width: 1px;
  height: 1px;
  clip: rect(0px, 0px, 0px, 0px);
  &:focus-visible + label {
    border: 2px dashed white;
    outline: 3px dashed #0e3487;
    outline-offset: 2px;
  }
  :checked + label {
    width: 80px;
    height: 80px;
    position: relative;
    right: -14px;
  }
`

const StyledLabel = styled.label<{
  inputColor: string
  $imageUrl: string
  $checked: boolean
}>`
  width: 39px;
  height: 39px;
  display: flex;
  border: 2px solid ${(p) => p.theme.colors.white};
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  background: url("${(p) => p.$imageUrl}");
  background-size: 100%;

  ${(p) => p.theme.breakpoints.up("md")} {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
`

const StyledRadioAndName = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 15px;
  margin-bottom: 15px;
  gap: 25px;
  padding-right: 30px;
  width: 100%;

  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
    border-bottom: 1px solid ${(p) => p.theme.colors.lightGray};
  }
`

const ItemDescription = styled.div<{ $selected: boolean }>`
  ${(p) => p.$selected && `margin-right: -30px;`}
  cursor: pointer;
  * {
    text-align: center;
  }
  display: flex;
  flex-grow: 1;
`
const StyledDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const ItemName = styled.p`
  font-family: ${Font.OENaPro};
  font-size: 16px;
  margin: 0;
  padding: 0;
  line-height: 22px;
  text-align: right;
`

const AdditionalCost = styled.p`
  font-size: 14px;
  margin: 0;
  padding: 0;
  color: ${(p) => p.theme.colors.disable};
  line-height: 20px;
`

const StyledNotInStock = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${(p) => p.theme.colors.mazdaRed};
  text-align: right;
  margin-right: auto;
  align-self: flex-start;
`
type Props = {
  type: "colors" | "upholstery"
  data: ColorCarouselProps[]
  selectedItem: string
  handleColorChange: (code: string) => void
}

const Colors = ({ type, data, selectedItem, handleColorChange }: Props) => {
  if (!selectedItem) return null

  return (
    <StyledContainer role="radiogroup" aria-labelledby="colorsHeadline">
      {data.map((item) => {
        let itemName = item.name
        const isSelected = item.code === selectedItem
        const imageUrl = item?.colorImage.imageUrl

        if (item.additionalPrice) {
          itemName += `, תוספת מחיר: ${item.additionalPrice}₪`
        }

        return (
          <StyledRadioAndName key={item.code} role="presentation">
            <StyledRadio
              type="radio"
              name={type}
              value={item.code}
              id={`radio_${type}_${item.code}`}
              checked={isSelected}
              onChange={() => {
                if (isSelected) return
                handleColorChange(item.code)
              }}
            />
            <StyledLabel
              inputColor={item?.hex || ""}
              aria-label={itemName}
              htmlFor={`radio_${type}_${item.code}`}
              $imageUrl={imageUrl}
              $checked={isSelected}
            ></StyledLabel>
            <ItemDescription
              $selected={isSelected}
              onClick={() => {
                if (isSelected) return
                handleColorChange(item.code)
              }}
            >
              <StyledDescriptionWrapper>
                <ItemName>{item.name}</ItemName>
                <AdditionalCost>
                  {item.additionalPrice > 0 &&
                    `תוספת מחיר: ${item.additionalPrice}`}
                </AdditionalCost>
              </StyledDescriptionWrapper>
              {!item.inStock && <StyledNotInStock>לא במלאי</StyledNotInStock>}
            </ItemDescription>
          </StyledRadioAndName>
        )
      })}
    </StyledContainer>
  )
}

export default Colors
